import { render } from "./CodigosNoMapeados.vue?vue&type=template&id=075c5cee&scoped=true"
import script from "./CodigosNoMapeados.vue?vue&type=script&lang=js"
export * from "./CodigosNoMapeados.vue?vue&type=script&lang=js"

import "./CodigosNoMapeados.vue?vue&type=style&index=0&id=075c5cee&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075c5cee"]])

export default __exports__